import ethereum from 'decentralized/ethereum.js';

export const getAllUsers = async () => {
    let users = await ethereum.encryption.getPotentialUsers();
    let userNames = [];
    let userData = [];
    for (let user of users) {
        let userName = await ethereum.users.getUserName(user);
        if (userName && userName !== '') {
            userData.push({
                id: user,
                userName: userName
            });
        }
    }
    console.log("USERS =", userData);
    return userData;
} 
